import React from 'react';
import { motion } from 'framer-motion';
import {
  Card,
  CardContainer,
  ShortInfoSectionStyles,
} from './ShortInfoSection.styles';
import icon1 from '../assets/images/icon-1.svg';
import icon2 from '../assets/images/icon-2.svg';
import icon3 from '../assets/images/icon-3.svg';

function ShortInfoSection() {
  // const cardVariants = {
  //   offscreen: { opacity: 0, y: -20 },
  //   onscreen: {
  //     opacity: 1,
  //     y: 0,

  //     transition: {
  //       duration: 0.8,
  //     },
  //   },
  // };

  const leftVariant = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.4, duration: 1.5 },
    },
  };

  const centerVariant = {
    offscreen: { scale: 0.6, opacity: 0, y: 50 },
    onscreen: {
      scale: 1,
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.3, duration: 2 },
    },
  };

  const rightVariant = {
    offscreen: { x: 50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.3, duration: 1.5 },
    },
  };

  const containerFadeIn = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3, // 0.2s delay between each child
        delayChildren: 0.5, // delay before first child starts
      },
    },
  };

  const fadeInImage = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: 0.4 },
    },
  };

  const fadeInText = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: 0.7 },
    },
  };

  const fadeInParagraph = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: 1 },
    },
  };

  return (
    <ShortInfoSectionStyles>
      <CardContainer>
        <Card
          variants={leftVariant}
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.8 }}
        >
          <motion.div
            variants={containerFadeIn}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.8 }}
          >
            <motion.img src={icon1} alt="" width={80} variants={fadeInImage} />
            <motion.h3 className="mt-2" variants={fadeInText}>Intuito</motion.h3>
            <motion.p variants={fadeInParagraph}>
              Una digital suite, studiata per semplificare il lavoro ai nostri collaboratori.
            </motion.p>
          </motion.div>
        </Card>
        <Card
          variants={centerVariant}
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.8 }}
        >
          <motion.div
            variants={containerFadeIn}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.8 }}
          >
            <motion.img src={icon2} alt="" width={80} variants={fadeInImage} />
            <motion.h3 className="mt-2" variants={fadeInText}>Strumenti</motion.h3>
            <motion.p variants={fadeInParagraph}>
              Le più moderne tecnologie e la migliore esperienza utente.
            </motion.p>
          </motion.div>

        </Card>
        <Card
          variants={rightVariant}
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.8 }}
        >
          <motion.div
            variants={containerFadeIn}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.8 }}
          >
            <motion.img src={icon3} alt="" width={80} variants={fadeInImage} />
            <motion.h3 className="mt-2" variants={fadeInText}>Risultati</motion.h3>
            <motion.p variants={fadeInParagraph}>
              La metà delle provvigioni maturate da Greenia, nel tuo portafogli!
            </motion.p>
          </motion.div>

        </Card>
      </CardContainer>
    </ShortInfoSectionStyles>
  );
}

export default ShortInfoSection;
